import { render, staticRenderFns } from "./PageConstructor.vue?vue&type=template&id=1cce5db8&scoped=true"
import script from "./PageConstructor.vue?vue&type=script&lang=js"
export * from "./PageConstructor.vue?vue&type=script&lang=js"
import style0 from "./PageConstructor.vue?vue&type=style&index=0&id=1cce5db8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cce5db8",
  null
  
)

export default component.exports